import { memo } from 'react';

import SelectedText from '../../SelectedText';

const File = ({ message }) => {
  return <SelectedText {...message.textChunk} />;
};

export default memo(File);
